import { render, staticRenderFns } from "./VideoPlayer.vue?vue&type=template&id=36465b7f&scoped=true&"
import script from "./VideoPlayer.vue?vue&type=script&lang=js&"
export * from "./VideoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./VideoPlayer.vue?vue&type=style&index=0&id=36465b7f&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36465b7f",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VideoNative: require('/opt/build/repo/components/Video/VideoNative.vue').default,VideoYoutube: require('/opt/build/repo/components/Video/VideoYoutube.vue').default,VideoPlayerUI: require('/opt/build/repo/components/Video/VideoPlayerUI.vue').default,ButtonPlay: require('/opt/build/repo/components/ButtonComponents/ButtonPlay.vue').default})
